export interface CollectionRemoveRequest {
  collections: {
    id: string
    revision: number
  }[]
  removeReason: string
  removeDate: string
  oneOnlyCheck: boolean
  fiveYearLendCheck: boolean
}

export function CollectionRemoveRequestToJSON(
  value: CollectionRemoveRequest
): any {
  return {
    collections:
      value.collections.length !== 0
        ? value.collections.map(collection => {
            return {
              id: collection.id !== '0' ? collection.id : undefined,
              revision:
                collection.revision !== 0 ? collection.revision : undefined
            }
          })
        : undefined,
    remove_reason: value.removeReason !== null ? value.removeReason : undefined,
    remove_date: value.removeDate !== '' ? value.removeDate : undefined,
    one_only_check:
      value.oneOnlyCheck !== null ? value.oneOnlyCheck : undefined,
    five_year_lend_check:
      value.fiveYearLendCheck !== null ? value.fiveYearLendCheck : undefined
  }
}
